export enum SessionDecisionType {
    satisfactoryReview = 0,
    potentialBreach = 1,
    confirmedBreach = 2,
  }
